<template>
  <el-table
    ref="listTable"
    class="c-page o-header-text-center"
    stripe
    border
    :data="processComment"
    :class="{ 'o-table-empty-center': processComment.length <= 0 }"
  >
    <el-table-column
      type="index"
      label="序号"
      width="34"
      align="center"
    />
    <el-table-column
      prop="activityName"
      label="办理环节"
      min-width="120"
      show-overflow-tooltip
    />
    <el-table-column
      prop="czrq"
      label="创建时间"
      width="200"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        {{ scope.row.czrq | date('yyyy-MM-dd HH:mm') }}
      </template>
    </el-table-column>
    <el-table-column
      prop="endTime"
      label="完成时间"
      width="200"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        {{ scope.row.endTime | date('yyyy-MM-dd HH:mm') }}
      </template>
    </el-table-column>
    <el-table-column
      prop="userName"
      label="办理人"
      min-width="80"
      show-overflow-tooltip
    />
    <el-table-column
      prop="state"
      label="状态"
      min-width="100"
      show-overflow-tooltip
    />
    <el-table-column
      prop="blyj"
      label="办理意见"
      min-width="240"
      show-overflow-tooltip
    />
  </el-table>
</template>

<script>
import { getProcessComment } from '../workflow.service';

export default {
  name: 'ProcessComment',
  props: {
    // 流程示例ID
    processInsId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      processComment: []
    };
  },
  methods: {
    init () {
      if (!this.processInsId) return;
      getProcessComment(this.processInsId).then(rsp => {
        this.processComment = rsp.data;
        /* if (rsp.data[rsp.data.length - 1].state === '已完成') {
          this.processComment = rsp.data;
        } else {
          this.processComment = rsp.data.splice(0, rsp.data.length - 1);
        } */
      });
    }
  },
  watch: {
    processInsId: function (newVal, oldVal) {
      if ((newVal && !oldVal) || (newVal !== oldVal)) {
        this.init();
      }
    }
  },
  created () {
    this.init();
  }
};
</script>

<style>

</style>
